var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4084 37.272C72.1419 39.5057 67.2476 41.4437 64.8497 42.3306C61.5649 43.5788 60.1196 44.0058 58.2801 44.5971C56.2107 45.2869 52.0391 46.5351 52.0391 46.5351C60.678 49.0972 66.7548 49.8856 66.7548 49.8856C66.7548 49.8856 69.5798 48.9987 74.0799 46.6008C76.5106 45.3526 77.6932 44.5314 78.5472 43.743C78.8757 43.4474 79.664 42.6262 79.8939 41.5422C79.8939 41.4765 79.9596 41.2466 79.9596 41.0495C79.9596 41.0495 79.9596 40.9181 79.9596 40.7867C79.9596 40.6553 79.9268 40.5568 79.9268 40.5568C79.9268 40.5568 79.8939 40.294 79.8282 40.1298C79.7626 39.9655 79.4998 39.4071 79.0399 39.0458C78.7443 38.8159 78.2187 38.1918 76.3464 37.5348C75.7223 37.3049 74.6711 37.1078 74.6711 37.1078L74.4084 37.272Z",
    fill: "url(#paint0_linear_709_1552)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9303 41.0166C79.9303 41.0166 79.9303 40.7867 79.8646 40.5896C79.8318 40.3925 79.7332 40.2283 79.6018 40.0641C79.4704 39.8341 79.2405 39.6042 78.9777 39.3086C78.7478 39.1115 78.5178 38.9144 78.2222 38.7173C77.0397 37.9618 75.5287 37.5019 74.1819 37.3377C72.1125 37.0749 69.7146 37.1078 69.4847 37.1078C68.7292 37.1078 63.7364 37.1406 62.4881 37.1735C56.8055 37.3049 49.8746 37.3049 48.068 37.3049C29.3119 37.4034 21.1328 36.9764 12.034 35.1698C4.31478 33.6259 0.0117188 32.1806 0.0117188 32.1806C6.84405 31.9507 46.6227 30.3083 53.882 30.1112C58.6449 29.9798 61.9954 29.947 64.7218 30.1112C66.1014 30.1769 67.3825 30.3083 69.0248 30.5711C70.4701 30.8338 71.7841 31.228 72.5724 31.5237C74.1819 32.1149 75.5615 33.0018 76.2185 33.8887C76.2185 33.8887 76.4156 34.0858 76.6784 34.4471C76.974 34.8741 77.3353 35.3997 77.4667 35.5968C78.4521 37.0749 78.912 38.0275 79.0762 38.356C79.2405 38.6845 79.4047 39.0458 79.569 39.4071C79.7004 39.7684 79.7661 39.9655 79.8317 40.0969C79.9303 40.4582 79.9631 40.7867 79.9631 40.8853L79.9303 41.0166Z",
    fill: "#CE210F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_709_1552",
    x1: 71.5386,
    y1: 34.549,
    x2: 61.4658,
    y2: 51.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0764,
    stopColor: "#BBCEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1854,
    stopColor: "#85A9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#5D8FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3543,
    stopColor: "#457EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3C78C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2E5C99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.17b5f2721046013f3f1e41314c990fcb.svg";
export { ForwardRef as ReactComponent };